<template>
         <div class="bgc">
           <div class="half">
             <div class="title">信用查询</div>
              <div class="inp"><el-input
                                v-model="keyword"
                                size="large"
                                placeholder="请输入关键字"
                            ></el-input></div>
               <div class="inp"><el-input
                                v-model="idCard"
                                size="large"
                                placeholder="请输入身份证号"
                            ></el-input></div>
                <div class="btn" @click="query(1)">
                  点击查询
                </div>
           </div>
            <div class="half2">
           </div>
         
         </div>
          <div style="margin-top: 20px;margin-left: 5%;width: 90%;" v-if="dataShow">
                <div style="border:1px solid #dcdcdc;height: 35px;line-height: 35px;color:#666;text-indent: 10px;" 
                 v-if="count==0">共{{count}}条结果。<span @click="handleOne()" class="noCompany">如无公司，点击此处查看个人信用</span></div>
                <div style="border:1px solid #dcdcdc;border-bottom: none;height: 35px;line-height: 35px;color:#666;text-indent: 10px;" 
                 v-if="count>0">共{{count}}条结果。<span @click="handleOne()" class="noCompany">如无公司，点击此处查看个人信用</span></div>
                 <div class="item-content" v-if="count>0">
                    <div v-for="data in dataList" class="item"  @click="showDetail(data)">
                        <div style="height: 80px;width:80px;float: left;margin-top:10px;">
                            <img :src="data.url" style="height: 70px;width: 70px;margin-top: 10px;">
                        </div>
                        <div style="width: calc(100% - 100px);margin-left:20px;float: left;margin-top:10px;">
                            <div style="height: 30px;">
                                <div class="company-name" style="float: left;font-weight: bold;font-size: 18px;">{{data.Name}}</div>
                                <div style="float: left;margin-left:10px;color: red;border:1px solid red ;
                                 font-size:10px;width: 30px;height: 14px;line-height:14px;text-align: center">{{data.Status}}</div>
                            </div>
                            <div style="margin-top:10px;float: left;width:50%;color: rgb(179,153,153)">法定代表人：<span style="color: #666666;">{{data.OperName}}</span></div>
                            <div style="margin-top:10px;float: left;width:50%;color: rgb(179,153,153)">成立日期：<span style="color: #666666">{{data.StartDate}}</span></div>
                            <div style="margin-top:10px;float: left;width:50%;color: rgb(179,153,153)">注册号：<span style="color: #666666">{{data.No}}</span></div>
                            <div style="margin-top:10px;float: left;width:50%;color: rgb(179,153,153)">信用代码：<span style="color: #666666">{{data.CreditCode}}</span></div>
                        </div>
                    </div>
                </div>
                 <div style="border:1px solid #dcdcdc;border-top: none;height: 35px;line-height: 35px;color:#666;text-indent: 10px;" 
                 v-if="count>0&&count>dataList.length">
                 <div style="margin-left:48%;cursor:pointer;" @click="query(0)"><i class="el-icon-arrow-down"></i></div>
                 </div>
          </div>

             <div style="margin-top: 20px;margin-left: 5%;width: 90%;" v-if="data2Show">
               <div class="content">
               <div class="label">个人老赖信息</div>
                    <div v-if="llTableData.length==0" style="text-align:center;margin:10px;">没有查询到老赖信息</div>
                    <table v-if="llTableData.length>0" class="dialog-table2" border="1" bordercolor="#dcdcdc">
                        <tr>
                            <td class="title2">名称</td>
                            <td>{{llTableData[0].Name}}</td>
                            <td class="title2">证件号</td>
                            <td>{{llTableData[0].CerNo}}</td>
                        </tr>
                        <tr @click="getLLDetail()">
                            <td class="title2">失信数量</td>
                            <td style="color:red;cursor:pointer;">{{llTableData[0].Count}}</td>
                        </tr>
                    </table>
               </div>

                <div class="content" v-if="llListDialogShow">
                    <div class="label">失信列表</div>
                    <table v-if="llListResult.length>0" class="dialog-table2" border="1" bordercolor="#dcdcdc">
                        <tr>
                            <td style="background-color: rgb(242,249,252);  width: 35%">案号</td>
                            <td  style="background-color: rgb(242,249,252);width: 35%">执行法院</td>
                            <td style="background-color: rgb(242,249,252);width: 15%">履行情况</td>
                            <td style="background-color: rgb(242,249,252);width: 15%">发布日期</td>
                        </tr>
                        <tr v-for="(abc,i) in llListResult">
                            <td>{{abc.CaseNo}}</td>
                            <td>{{abc.ExecuteGov}}</td>
                            <td>{{abc.ExecuteStatus}}</td>
                            <td>{{abc.PublicDate}}</td>
                        </tr>
                    </table>
                </div>
          </div>

</template>

<script>
import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped>

.noCompany{
  margin-left:10px;cursor:pointer;
}
 .noCompany:hover{
        color:#3a85c6;
    }

.bgc{
    background-color:#F8F8F8 ;
    height: 500px;
    margin: 20px;
}
.half{
  width: 50%;
  float: left;
  text-align: center;
}
.half2{
  width: 50%;
  height: 100%;
  float: left;
  background-image: url(../../assets/img/searchCredit.png);
  background-size:500px 500px;
  background-repeat:no-repeat;
}

.inp{
  width: 60%;
  margin-left:20%;
  margin-top: 40px;
}
.title{
  margin-top: 80px;
  color:#03C1B2;
  font-size: 30px;
  font-weight: bold;
}
.btn{
  margin-top: 50px;
  border-radius: 20px;
  height: 40px;
  line-height: 40px;
  background-color: #03C1B2;
  width: 160px;
  margin-left: calc(50% - 80px);
  letter-spacing: 3px;
  color:#fff;

}
 .inp >>>.el-input__inner {
        border-radius: 23px;
        height: 45px;
        text-align: center;
        letter-spacing: 1px;
      }

        .item-content{
        border:1px solid #dcdcdc;
        border-top: none;
    }
    .item{
        height: 120px;
        padding: 15px 30px;
        border-top: 1px solid #dcdcdc;
        cursor:pointer;
    }
    .item:hover .company-name{
        color:#3a85c6;
    }

    .label{
        font-weight: bold;
        margin-bottom: 10px;
    }
     .dialog-table2{
        border-collapse:collapse;
        width: 100%;
    }
    .dialog-table2 tr td{
        height: 40px;
        line-height: 40px;
        /*text-indent: 10px;*/
        padding-left: 10px;
    }
    .dialog-table2 .title2{
        background-color: rgb(242,249,252);
        width: 14%;
    }
    .dialog-table2.content{
        width: 11%;
    }
</style>